import { provideApolloClient, useQuery } from '@vue/apollo-composable';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { apolloClient } from '../services/ApolloClient';
import { getOfflineTimetablesQuery } from './queries';
import { OfflineTimetablesResult } from '../apiTypes';

provideApolloClient(apolloClient);

const offlineTimetableResults = ref<OfflineTimetablesResult[]>();
const isLoading = ref<boolean>(false);

const processResult = ((queryResult, document) => {
  if (document.value.loc?.source.body === getOfflineTimetablesQuery.loc?.source.body) {
    offlineTimetableResults.value = queryResult.data?.timetables;
  }
});

export const offlineTimetableStoreDefinition = {
  state: () => ({
    offlineTimetableResults,
  }),
  actions: {
    async requestOfflineTimetables(originPortName: string, destinationPortName: string) {
      const {
        refetch,
        onResult,
        onError,
        loading,
        document,
      } = useQuery(getOfflineTimetablesQuery, {
        originPortName,
        destinationPortName,
      });
      isLoading.value = loading.value;

      onError((error) => {
        isLoading.value = loading.value;
        console.log('requestOfflineTimetables: error', error);
      });

      onResult((queryResult) => {
        isLoading.value = loading.value;
        processResult(queryResult, document);
      });

      await refetch();
    },
  },
  getters: {
    getOfflineTimetables: () => offlineTimetableResults.value,
  },
};

export const useOfflineTimetableStore = defineStore('offlineTimetableStore', offlineTimetableStoreDefinition);
